import React from "react";

const PageTitleReservation = () => {
  return (
    <div id="page-title">
      <div className="wrapper text-center">
        <h1 className="large">Réservation</h1>
      </div>
    </div>
  );
};

export default PageTitleReservation;
